import { createSelector } from 'reselect';

import {
  selectBasketItemsEntitySelectedFreebetId,
  selectBasketItemsEntityStatus,
  selectBasketSelectedFreebetId,
  selectBasketStatus,
} from '../../../../selectors/basket/basketPrimary.selector';
import { BasketStatuses } from '../../../../types/basket';
import { Selector } from '../../../../types/selectors';
import { selectBasketEligibleMission } from '../../selectors/basket';

const selectBasketBetslipMissionEligibleLabel: Selector<string | undefined> = createSelector(
  [selectBasketEligibleMission],
  (eligibleMission) => eligibleMission?.title,
);

const selectBasketBetslipMissionIsVisible: Selector<boolean> = createSelector(
  [
    selectBasketStatus,
    selectBasketItemsEntityStatus,
    selectBasketSelectedFreebetId,
    selectBasketItemsEntitySelectedFreebetId,
  ],
  (basketStatus, basketItemStatus, basketSelectedFreebetId, basketItemSelectedFreebetId) => {
    return (
      !basketSelectedFreebetId &&
      !basketItemSelectedFreebetId &&
      (basketStatus === BasketStatuses.VALIDATED || basketItemStatus === BasketStatuses.VALIDATED)
    );
  },
);

type BasketBetslipMissionEligibleTagContainerPropsType = {
  isVisible: boolean;
  label?: string;
};

const selectBasketBetslipMissionEligibleTagContainerProps: Selector<BasketBetslipMissionEligibleTagContainerPropsType> =
  createSelector(
    [selectBasketBetslipMissionEligibleLabel, selectBasketBetslipMissionIsVisible],
    (label, isVisible) => ({
      isVisible,
      label,
    }),
  );

export default selectBasketBetslipMissionEligibleTagContainerProps;
